import styled from 'styled-components'

const TextUnderLine = styled.input`
  background: transparent;
  border: none;
  border-bottom: 1px solid #000000;
  min-height: calc(1.5em + 1.65rem + 2px);
  font-size: 1.15rem;
`

export const FormRadioUnderLine: React.FC<{
  field: {name: string; value: any; onChange: () => void}
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  gValue: string
  gName: string
  label: string
  setRelateField?: string
  underlinName: string
  underlinValue: string
  disabled?: boolean
}> = (props) => {
  return (
    <label className='d-flex align-items-center justify-content-between cursor-pointer mb-6'>
      <span className='form-check form-check-custom form-check-solid'>
        <input
          type='radio'
          className='form-check-input'
          name={props.gName}
          value={props.gValue}
          checked={props.field.value.toString() === props.gValue}
          onChange={(val) => {
            val && props.form.setFieldValue(props.field.name, props.gValue)
            props.setRelateField && props.form.setFieldValue(props.setRelateField, props.label)
          }}
          disabled={props.disabled}
        />
        {props.underlinName ? (
          <span className='d-flex align-items-center ms-5'>
            <span className='fs-6'>{props.label}</span>
            <span className='form-check-label text-dark fs-6'>
              <TextUnderLine
                type='text'
                className=''
                name={props.underlinName}
                value={props.underlinValue}
                disabled={props.disabled}
                onChange={(val) => {
                  val && props.form.setFieldValue(props.underlinName, val.target.value)
                }}
              />
            </span>
          </span>
        ) : (
          <span className='d-flex align-items-center ms-5'>
            <span className='fs-6'>{props.label}</span>
          </span>
        )}
      </span>
    </label>
  )
}
